module.exports = __webpack_public_path__ + "static/media/rodeo-logistics-powered-by-desktop-logo.50e2328d.svg";